<template>
  <div class="py-6 bg-red-600 text-white text-center" v-if="networkError">You are offline. Please check your internet
    connection
  </div>
  <router-view/>
</template>
<script>


var SpatialNavigation = window.SpatialNavigation;

export default {
  name: 'App',
  components: {},
  data() {
    return {
      networkError: false
    }
  },
  methods: {
    enterPressed() {

    },
    handleReturnButton() {
      // Show a prompt before exiting the app
      var confirmExit = window.confirm("Are you sure you want to exit the app?");

      if (confirmExit) {
        // Close the app if the user confirms
        window.close();
      }
    }

  },
  mounted() {
    // Initialize
    SpatialNavigation.init();
    // Define navigable elements (anchors and elements with "focusable" class).
    SpatialNavigation.add({
      selector: '.menu-item,.video'
    });
    window.addEventListener('sn:focused', (e) => {
      [].forEach.call(document.querySelectorAll('.active'), function (el) {
        el.classList.remove('active');
      })
      e.target.classList.add('active');
      var active = document.querySelectorAll('.active')[0];
      if (active) active.focus();
    });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
        console.log('V CHanged')
        location.reload();
      }
    });


    window.addEventListener("keydown", (e) => {
      console.log(e);
      console.log(navigator.userAgent);
      const isTizen = navigator.userAgent.indexOf('Tizen') > -1 || navigator.userAgent.indexOf('tizen') > -1
      switch (e.keyCode) {
        case 13:    // Enter
        case 461:    // Enter
          // var active = document.querySelectorAll('.active')[0];
          //   active.click();
          break;
        case 10009: // Back
          if (isTizen) {
            var fullPath = this.$router.currentRoute.value.fullPath;
            if (fullPath === '/') {
              this.handleReturnButton();
              return;
            }
            e.preventDefault();
            history.back();
          }
          break;
        case 38: 	// ArrowUp
          //console.log(focusControllerInstance.getCurrentFocusItem());
          break;
        case 40: 	// ArrowDown
          break;
        case 37: 	// ArrowLeft
          break;
        case 39: 	// ArrowRight
          break;
        case 415: 	// MediaPlay
          break;
        case 19: 	// MediaPause
          break;
        case 413: 	// MediaStop
          break;
        case 417: 	// MediaFastForward
          break;
        case 412: 	// MediaRewind
          break;
        default:
          console.log(e.keyCode)
      }
    });
    window.addEventListener("offline", () => {
      this.networkError = true;
    }, false);

    window.addEventListener("online", () => {
      this.networkError = false;
    }, false);
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

$red: #b9454c;
@tailwind base;
@tailwind components;
@tailwind utilities;
.header-menu {
  background-color: #fff;
  box-shadow: 0px 0px 10px #e3e3e3;
}

body {
  font-family: "Poppins", serif;
}

.menu-item {
  font-family: 'Roboto Condensed', serif;
  @apply p-4 hover:no-underline m-1 focus:no-underline  inline-block text-[22px] no-underline px-10 transition-all rounded-full block clear-both focus:bg-red-600 rounded-full focus:text-white  focus:outline-0;
  &.active {
    @apply bg-red-600 text-white shadow rounded-full    ;
    background: #e23e48;
    color: #fff;
  }
}

.router-link-exact-active {
  background-color: #000000;
  color: white;
}

.yt-video {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  background-color: #fff;
  border: 5px solid #ffffff;
}

.yt-video.active {
  border: 5px solid red;
  transform: scale(1.1);
}


#app {
  height: 100%;
  @apply bg-gray-100 overflow-auto;
  background-color: #f3f3f3;
}

body {
  height: 100%;
  @apply overflow-hidden;
}

html {
  height: 100%;
  @apply bg-gray-50;
}

.video {
  background: #ffffff;
  color: black;
  text-align: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.video:focus {
  outline: 0;
  border: 5px solid red;
  transform: scale(1.1);
}

.video {
  background-color: #ffffff;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #000;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.active-2 {
  background-color: #000000;
  color: white;
}


</style>
